export default __webpack_public_path__ + "static/media/Resume_HARSHVBHANDARI.aaad77eb.pdf";